import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../../util/reactIntl';
import classNames from 'classnames';

import css from './SectionProjects.module.css';
import { ListingCard, NamedLink } from '../../../../../components';

const SectionProjects = props => {
    const { rootClassName, className, listings, projects } = props;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.subTitle}>
                Looking for a job?
            </div>
            <div className={css.title}>
                Explore our projects
            </div>
            <p className={css.text}>
                We strive to make your next job search process easier.
            </p>
            <div className={css.cards}>
                {projects.map(l => {
                    return <ListingCard key={l.id.uuid} listing={l} />;
                })}
            </div>
            <div className={css.bottomWrapper}>
                <NamedLink name="SearchPage"
                    params={{ tab: 'projects' }}
                    className={css.bottomLink}>
                    <FormattedMessage id="TopbarDesktop.findProjects" />
                </NamedLink>
            </div>
        </div>
    );
};

SectionProjects.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionProjects.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionProjects;
